import axios from '@/axios'
const bindAccount = {
  // 绑定真实
  async realAccount(params) {
    return await axios.post('/uc/user/bind/realAccount', params, { des: '直客pc绑定真实', sTime: new Date().getTime() })
  },
  // 绑定模拟
  async simulatorAccount(params) {
    return await axios.post('/uc/user/bind/simulatorAccount', params, { des: '直客pc绑定模拟', sTime: new Date().getTime() })
  },
  // 激活真实
  async realAccountAc(params) {
    return await axios.post('/uc/user/activation/realAccount', params, { des: '直客pc激活真实', sTime: new Date().getTime() })
  },
  // 激活模拟
  async simulatorAccountAc(params) {
    return await axios.post('/uc/user/activation/simulatorAccount', params, { des: '直客pc激活模拟', sTime: new Date().getTime() })
  },
  // 激活真是验证身份证
  realUserData(params) {
    return axios.post('/web/realaccount/validate', params, { async: false, des: '直客pc激活真是验证身份证', sTime: new Date().getTime() })
  }
}

export default bindAccount


// WEBPACK FOOTER //
// ./src/api/bindAccount.js